// extracted by mini-css-extract-plugin
export default {"tapeBody":"light_tapeBody__IG31Y color_colorLightBorder__6Pa4H","overflow":"light_overflow__uo16B color_colorLightBorder__6Pa4H color_colorLightBackground__vzlHN"};